import { render, staticRenderFns } from "./Payslips.vue?vue&type=template&id=be350c9a&scoped=true&"
import script from "./Payslips.vue?vue&type=script&lang=js&"
export * from "./Payslips.vue?vue&type=script&lang=js&"
import style0 from "./Payslips.vue?vue&type=style&index=0&id=be350c9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be350c9a",
  null
  
)

export default component.exports